module.exports = __webpack_public_path__ + "img/order-tab.43a02f14.png";